import { reject } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { EVENT } from 'features/common/gtm/constants';

// used in thunks after successful data filter fetch
export const pushToFilterDataLayer = ({ filterSection, formData, formDataFieldsMap }) => {
	const cleansedFormData = reject(isNilOrEmpty)(formData);
	const formDataKeys = Object.keys(cleansedFormData);
	const filledFormFields = formDataKeys.map((key) => formDataFieldsMap[key]);
	const filterFields = filledFormFields.join(',');

	window?.dataLayer &&
		window.dataLayer.push({
			event: EVENT.filter,
			filter_section: filterSection,
			filter_type: filterFields,
		});
};
